// const color = window.color_config; //['rockerzs'];
// const {
//   buttonBg,
//   buttonBorder,
//   buttonHover,
//   buttonFront,
//   seeAll,
//   heading,
//   hover,
//   switchBg,
//   switchfront
// } = color;

const rootVariables = () => {
  return `
  :root{
    --button-bg:${window?.color_config?.buttonBg || "#E50019"};
    --button-border:${window?.color_config?.buttonBorder || "#E50019"};
    --button-hover:${window?.color_config?.buttonHover || "#a31f2d"};
    --button-front:${window?.color_config?.buttonFront || "white"};
    --se-all:${window?.color_config?.seeAll || "#E50019"};
    --heading-color:${window?.color_config?.heading || "currentColor"};
    --hover-color:${window?.color_config?.hover || "#E50019"};
    --switch-bg:${window?.color_config?.switchBg || "#a31f2d"};
    --switch-front:${window?.color_config?.switchfront || "#E50019"};
    --silver:  #777777;
    --black-pearl:#000F1E;
    --black: #000000;
    --off-black:rgba(0, 0, 0, .7);
    --pink-red: #f70060;
    --dark-hot-pink: #e30061;
    --reddish-pink: #ff2c52;
    --white: #ffffff;
    --off-white: #fafafa;
    --white-60: rgba(255, 255, 255, 0.6);
    --white-87: rgba(255, 255, 255, 0.87);
    --navy-blue:#141e29;
    --dark-navy-blue: #000f1e;
    --dark-navy-blue-two: #000d1a;
    --dark-navy-blue-60: rgba(0, 15, 30, 0.6);
    --dark-navy-blue-87: rgba(0, 15, 30, 0.87);
    --background-primary: var(--dark-navy-blue);
    --background-secondary: var(--black);
    --color-primary: var(--pink-red);
    --color-secondary: var(--white-87);
    --color-tertiary: var(--white-60);
    --border-primary: var(--reddish-pink);
    --font-family: Roboto;
    --font-size-base: 16px;
    --font-weight-base: normal;
    --line-height-base: 1.5;
    --body-color: var(--color-secondary);
    --body-text-align: left;
    --body-bg: var(--background-primary);
    --headings-margin-bottom: 10px;
    --paragraph-margin-bottom: 10px;
    --headings-font-family: var(--font-family);
  }
  `;
};

export default rootVariables;